var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17549 1.66943L0.673324 7.17217C0.645611 7.19988 0.625735 7.23505 0.616179 7.2727L0.00631363 9.72057C-0.0118428 9.79434 0.0097538 9.8727 0.0634586 9.92641C0.104167 9.96711 0.159592 9.98967 0.216355 9.98967C0.233747 9.98967 0.251521 9.98756 0.268722 9.98317L2.71659 9.3733C2.75482 9.36375 2.78941 9.34387 2.81712 9.31616L8.31986 3.8138L6.17549 1.66943Z",
    fill: "#C3C3C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68309 0.919432L9.07055 0.306892C8.66136 -0.102488 7.94791 -0.102106 7.53891 0.306892L6.78857 1.05723L8.93275 3.20141L9.68309 2.45107C9.88759 2.24657 10.0002 1.97461 10.0002 1.68525C10.0002 1.3959 9.88759 1.12393 9.68309 0.919432Z",
    fill: "#C3C3C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24407 8.35645H5.20589C4.78853 8.35645 4.4502 8.69478 4.4502 9.11214V9.23407C4.4502 9.65143 4.78853 9.98976 5.20589 9.98976H9.24407C9.66142 9.98976 9.99976 9.65143 9.99976 9.23407V9.11214C9.99976 8.69478 9.66142 8.35645 9.24407 8.35645Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.a05ddd5fcb7792588bc80ae615e2f04f.svg";
export { ForwardRef as ReactComponent };